import React from "react"
import PropTypes from "prop-types"
import {observer} from "mobx-react"
import CalendarStore from "./CalendarStore"
import 'moment/locale/fr';

@observer
class Duration extends React.Component {
  constructor(props) {
    super(props);
    CalendarStore.duration = props.duration
    this.state= {
    }
  }

  render () {
      return (
        <React.Fragment>
        <div className="container row">
          <p>Durée estimée du rendez vous</p>
          <div className="input-field col s4">
            <input type="number" min='60' id="number" onChange={(e)=> CalendarStore.duration = e.target.value}value={CalendarStore.duration}/>
            <label className="active" htmlFor="number">Durée (minutes)</label>
          </div>
        </div>

        </React.Fragment>
      );
  }
}

export default Duration
